module.exports = __webpack_public_path__ + "static/media/apd_logo.0bf22493.png";